import styled from "styled-components";

export const CloseButton = styled.div`
  cursor: pointer;
  position: absolute;
  right: 30px;
  top: 20px;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #402680;
    }
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  button {
    margin: 20px 5px;
  }
`;

export const ActionConfirmation = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.1em;
  flex-direction: column;
  justify-content: space-evenly;

  span {
    font-weight: 700;
    margin: 0 4px;

    &:last-child {
      margin: 0 0 0 4px;
    }
  }
`;

export const ActionConfimationIcon = styled.div`
  font-size: 4em;
  color: #a8a8a8;
`;

export const ActionConfirmationMessage = styled.div`
  width: 500px;
  text-align: center;
`;

export const Divider = styled.div``;

export const DeclineButton = styled.div`
  margin: 20px 0;
  text-decoration: underline;
  font-size: 0.85em;
  color: #79D9D9;
  font-weight: 700;
  transition: 0.1s ease-in-out;
  cursor: pointer;

  &:hover {
    color: #402680;
  }
`;
